
































import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import VoteButton from '@/components/VoteButton/index.vue';
const mockDetail: any[] = [
  {
    showType: 1,
    value:
      'http://image.cqrb.cn/d/file/image/WrCrQJBM9QCuIwJHlfj19AVQEdBqPFSe0jTWK35j.png',
  },
  { showType: 2, value: '标题' },
  { showType: 7, value: '副标题副标题' },
  { showType: 4, value: '点赞数: 999' },
  { showType: 3, value: '点赞按钮' },
  {
    showType: 5,
    value:
      '详情介绍：重庆两江新区第一人民医院呼吸与危重医学科是以呼吸道慢病及常见病、呼吸危重症、呼吸介入及呼吸康复治疗为主，集临床、教学、科研为一体的综合性科室，开放病床80张，设有呼吸重症抢救室、气管镜室、肺功能及过敏原诊断室、睡眠呼吸诊疗室，常年开设有呼吸慢病门诊、哮喘门诊、戒烟门诊及咳嗽门诊，年收治病人3500人次/年，门诊量35000人次/年左右。',
  },
  {
    showType: 6, // item 的序号或者id
    value: 1,
  },
];
@Component({
  components: {
    VoteButton,
  },
})
export default class ListItem extends Vue {
  @Prop({
    default: () => {
      return mockDetail;
    },
  })
  voteItem!: any;
  @Prop({ default: false }) mustApp!: boolean;
  @Prop() voteName!: string;
  @Prop({ default: true }) voteWeChat!: boolean;
  @Emit()
  navTo() {
    return console.log('emit from vote item');
  }
}
